import PropTypes from 'prop-types';
import { ModalConfirm } from '@evertrue/et-components';
import { useInteractionFormContext } from '../context/interaction-form-context';

const InteractionFormContainer = ({
  isPinned,
  isComment,
  saveLabel,
  cancelLabel,
  disableSave,
  hasInteractionWrites,
  onCancel = () => {},
  handleSubmit = () => {},
  children,
}) => {
  const { editing } = useInteractionFormContext();
  const headerText = editing ? 'Edit' : 'Add';

  return (
    <ModalConfirm
      hasMargin
      saveLabel={saveLabel}
      cancelLabel={cancelLabel}
      onCancel={onCancel}
      onSubmit={isComment ? undefined : handleSubmit} // This is important -- we submit comments differently than other interactions
      disableSave={disableSave}
      header={
        <>
          {hasInteractionWrites && !isComment ? (
            <span>{`${headerText} Interaction`}</span>
          ) : isComment && isPinned ? (
            <span>{`${headerText} Pinned Comment`}</span>
          ) : (
            <span>Add Comment</span>
          )}
        </>
      }
    >
      {children}
    </ModalConfirm>
  );
};

InteractionFormContainer.propTypes = {
  isPinned: PropTypes.bool,
  isComment: PropTypes.bool,
  saveLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  disableSave: PropTypes.bool,
  hasInteractionWrites: PropTypes.bool,
  onCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default InteractionFormContainer;
